import { graphql } from 'react-relay';

export const gqlImportInstitutionListingsV2 = graphql`
  mutation importInstitutionListingsV2Mutation($institution: Int!, $feedType: Int!, $autoApply: Boolean!) {
    invsysImportInstitutionListingsV2(institution: $institution, feedType: $feedType, autoApply: $autoApply) {
      success
    }
  }
`;
